module.exports = __webpack_public_path__ + "static/media/chat_white.9a7a5b2b.svg";